import { useState } from 'react'
import { View, Text, Image, Pressable } from 'react-native'
import { useNavigate } from 'react-router-dom'
import { AnimatePresence, motion } from 'framer-motion'
import useDimension from '../../hooks/use-dimension'
import PageBg from '../../components/PageBg'
import Story from '../../components/elements/Story'
import { stories } from '../../data/contents'
import { imgIntro } from '../../data/images'
import SelectRoleModal from '../../components/modal/SelectRoleModal'
import { useGameContext } from '../../context/GameContext'

const { bgIntro1, bgIntro2, bgRole, btnNext, roles } = imgIntro
const roleArr = [
  { key: 'a', name: '李澤言', img: roles[0] },
  { key: 'b', name: '白起', img: roles[1] },
  { key: 'c', name: '許墨', img: roles[2] },
  { key: 'd', name: '周棋洛', img: roles[3] },
  { key: 'e', name: '凌肖', img: roles[4] },
]

const Intro = () => {
  const { ws } = useDimension()
  const { updateRole } = useGameContext()

  const navigate = useNavigate()

  const pLast = 2
  const [page, setPage] = useState<number>(0)

  const onNext = () => setPage(p => p + 1)

  const toIntroRole = () => navigate('/introrole', { replace: true })

  const [verify, setVerify] = useState(false)
  const [roleText, setRoleText] = useState<JSX.Element | string>('')
  const [roleKey, setRoleKey] = useState('')

  const onSelect = (name: string, key: string) => {
    setVerify(true)
    setRoleText(() => (
      <>
        確定與
        <Text style={{ fontWeight: 'bold' }}>{name}</Text>
        一同展開星石重生的旅程嗎？ （按下確定後，無法重新選擇）
      </>
    ))
    setRoleKey(key)
  }
  const onClose = () => {
    setVerify(false)
  }
  const onYes = () => {
    updateRole(() => roleKey)
    // if (roleKey && isPlaying) {
    //   setVolumeValue(0.3)
    //   sound.play()
    // }
    toIntroRole()
  }
  return (
    <AnimatePresence>
      <motion.div
        key={page}
        initial={{ opacity: 0.65 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 1 }}
        style={{
          position: 'absolute',
          width: '100%',
          height: '100%',
        }}
      >
        <PageBg
          src={page === 0 ? bgIntro1 : page === 1 ? bgIntro2 : bgRole}
          alt={`bg-intro`}
        >
          {page === pLast && (
            <>
              <motion.div
                style={{
                  width: 310 * ws,
                  position: 'absolute',
                  top: 60.5 * ws,
                  zIndex: 20,
                }}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 1 }}
              >
                <div
                  // key={pIndex}
                  style={{
                    width: '100%',
                    justifyContent: 'center',
                    padding: 10 * ws,
                    // marginBottom:
                    //   pIndex < paragraphs.length - 1 ? 16 * ws : 0,
                    backgroundColor: '#fffd',
                    boxShadow: '0px 0px 50px 30px #fff',
                  }}
                >
                  <Text
                    style={{
                      color: '#1f4d75',
                      fontFamily: 'love',
                      lineHeight: 20,
                      letterSpacing: 1.45 * ws,
                      fontSize: 14 * ws,
                    }}
                  >
                    就在此刻，連接隔壁車廂的門緩緩打開，一位讓你心跳加速的男子走了進來。他是……
                  </Text>
                </div>
              </motion.div>
              <motion.div
                style={{
                  width: 343 * ws,
                  height: 380 * ws,
                  position: 'absolute',
                  zIndex: 20,
                  top: 140 * ws,
                  flexDirection: 'row',
                  flexWrap: 'wrap',
                  justifyContent: 'center',
                  gap: 10 * ws,
                }}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 1, delay: 1 }}
              >
                <View
                  style={{
                    flexDirection: 'row',
                    flexWrap: 'wrap',
                    justifyContent: 'center',
                    gap: 10 * ws,
                  }}
                >
                  {roleArr.map((v, i) => {
                    return (
                      <View
                        key={v.key}
                        style={{
                          width: 134 * ws,
                          height: 149 * ws,
                          position: 'relative',
                          marginInline: 10,
                        }}
                      >
                        <Pressable
                          style={{
                            position: 'absolute',
                            width: '100%',
                            height: '100%',
                          }}
                          onPress={() => onSelect(v.name, v.key)}
                        >
                          <Image
                            source={{ uri: v.img }}
                            style={{
                              width: '100%',
                              height: '100%',
                            }}
                            resizeMode="contain"
                          ></Image>
                        </Pressable>
                      </View>
                    )
                  })}
                </View>
              </motion.div>
            </>
          )}
          <motion.div
            className="motion-wrapper txt-story"
            key={page}
            style={{ margin: '10%' }}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ delay: 0.3, duration: 0.5 }}
          >
            <Story
              btn={{
                btnSrc: page === pLast ? '' : btnNext,
                onPress: page === pLast ? () => {} : onNext,
              }}
              txts={page === pLast ? [] : stories.intro[page]}
            />
          </motion.div>
          <SelectRoleModal
            showModal={verify}
            onYes={onYes}
            onClose={onClose}
            txt={roleText}
          />
        </PageBg>
      </motion.div>
    </AnimatePresence>
  )
}

export default Intro
